import { useMemo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useGetLiveGuests } from '../../../../../hooks/queries/guests/use-get-live-guests'
import { useGetMyProfileMini } from '../../../../../hooks/queries/profile/use-get-my-profile-mini'
import { useGetOtherProfile } from '../../../../../hooks/queries/profile/use-get-other-profile'
import { useGlobalStore } from '../../../../../store/global-store'
import type { LiveGuest } from '../../../../../types/lives/live'

export const ALLOW_SEND_FOR_ME = true

export const useGetDataSeats = () => {
  const { liveUserId } = useGlobalStore(
    useShallow((state) => ({
      liveUserId: state.liveUserId,
    })),
  )

  const { user: liveUser } = useGetOtherProfile(liveUserId as number)
  const { user } = useGetMyProfileMini()
  const { guests } = useGetLiveGuests()

  const isStreamer = useMemo(() => {
    return Number(liveUserId) === Number(user?.id)
  }, [liveUserId, user?.id])

  const dataWithStreamerAndMe = useMemo(() => {
    return [
      {
        user: liveUser,
        userId: liveUserId,
        position: 0,
      } as unknown as LiveGuest,
      ...guests,
    ]
  }, [guests, liveUser, liveUserId])

  const dataSeats: LiveGuest[] = useMemo(() => {
    const dataWithouMe = !isStreamer ? dataWithStreamerAndMe : guests

    return ALLOW_SEND_FOR_ME ? dataWithStreamerAndMe : dataWithouMe
  }, [isStreamer, guests, dataWithStreamerAndMe])

  const formatedDataSeats = dataSeats
    ?.filter((item) => !!item.user)
    ?.filter((item) => {
      return ALLOW_SEND_FOR_ME
        ? item
        : Number(item?.userId) !== Number(user?.id)
    })
    ?.sort((a, b) => a?.position - b?.position)

  return {
    formatedDataSeats,
    dataSeats,
  }
}
